<template>
  <div class="availability-page">
    <h2>教练可用时间</h2>

    <!-- 添加可用时间按钮和查询框 -->
    <div class="actions">
      <el-button type="primary" @click="showAddDialog = true">添加可用时间</el-button>
      <el-input placeholder="查询教练编号" v-model="searchJiaolianbianhao" class="search-input"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="searchAvailability">查询</el-button>
    </div>

    <!-- 表格展示教练可用时间 -->
    <el-table :data="availabilityList" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="50" />
      <el-table-column prop="coachId" label="教练编号" width="100" />
      <el-table-column prop="availableFrom" label="开始时间" width="180" />
      <el-table-column prop="availableUntil" label="结束时间" width="180" />
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="editAvailability(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleteAvailability(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalItems"
      :page-size="pageSize"
      @current-change="handlePageChange"
    ></el-pagination>

    <!-- 添加/修改对话框 -->
    <el-dialog title="设置可用时间" :visible.sync="showAddDialog">
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="教练编号">
          <el-input v-model="form.coachId" :disabled="isEditing" />
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.availableFrom"
            type="datetime"
            placeholder="选择开始时间"
            format="yyyy-MM-dd HH:mm"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.availableUntil"
            type="datetime"
            placeholder="选择结束时间"
            format="yyyy-MM-dd HH:mm"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" @click="saveAvailability">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      availabilityList: [],
      form: {
        id: null,
        coachId: '',
        availableFrom: '',
        availableUntil: '',
      },
      searchJiaolianbianhao: '',
      showAddDialog: false,
      isEditing: false,
      pageSize: 10,
      totalItems: 0,
      currentPage: 1,
    };
  },
  created() {
    this.fetchAvailability();
  },
  methods: {
    // 获取可用时间列表
    fetchAvailability() {
      const coachId = localStorage.getItem('adminName').replace(/"/g, ''); // 获取当前登录教练编号
      if (!coachId) {
        this.$message.error('无法获取登录信息');
        return;
      }
      console.log("coachId", coachId);
      const cleanCoachId = coachId.replace(/['"]+/g, ''); // 移除可能存在的引号
  const queryString = `/schedule/${cleanCoachId}/availability`;
      
      // const queryString = `/schedule/${coachId}/availability`;
      console.log("queryString", queryString);
      
      this.$http
    // .get('/schedule/getAllAvailability', {
    //   params: {
    //     page: this.currentPage,
    //     limit: this.pageSize,
    //     // jiaolianbianhao: this.searchJiaolianbianhao || '',
    //   },
    // })
    .get(queryString)
    .then((response) => {
      // 假设 response.data.data 是我们需要的数组
      const data = response.data.data;
      console.log("data", response);
      this.availabilityList = data; // 直接将数据赋值给 availabilityList
      this.totalItems = data.length; // 设置总项数
    })
    .catch((error) => {
      this.$message.error('获取数据失败');
      console.error(error);
    });
    },
    // 搜索功能
    searchAvailability() {
      this.currentPage = 1;
      this.fetchAvailability();
    },
    // 修改功能
    editAvailability(row) {
      this.isEditing = true;
      this.form = { ...row };
      this.showAddDialog = true;
    },
//     editAvailability(row) {
//   this.isEditing = true;
//   this.form = { ...row };
//   this.showAddDialog = true;
// console.log("row", row);

//   // 构建查询字符串
//   const queryString = `?id=${encodeURIComponent(row.id)}&availableFrom=${encodeURIComponent(row.availableFrom)}&availableUntil=${encodeURIComponent(row.availableUntil)}`;

//   // 发送 POST 请求
//   this.$http.post(`/schedule/updateAvailabilityById${queryString}`)
//     .then(() => {
//       this.$message.success('更新成功');
//       this.fetchAvailability();
//     })
//     .catch((error) => {
//       this.$message.error('更新失败');
//       console.error(error);
//     });
// },

    // 删除功能
    deleteAvailability(id) {
      console.log("delete id", id);
      const queryString = `?id=${encodeURIComponent(id)}`;

      this.$confirm('确定要删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return this.$http.post(`/schedule/deleteAvailability${queryString}`);
        })
        .then(() => {
          this.$message.success('删除成功');
          this.fetchAvailability();
        })
        .catch((error) => {
          this.$message.error('删除失败');
          console.error(error);
        });
    },
    formatDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:00`;
    },
    // 添加或保存可用时间
    saveAvailability() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("this.form.availableFrom",this.form.availableFrom);
          console.log("this.formatDate(this.form.availableFrom)",this.formatDate(this.form.availableFrom));
          console.log("encodeURIComponent(this.form.availableFrom)",encodeURIComponent(this.form.availableFrom));

          const queryString = `?id=${encodeURIComponent(this.form.id)}&availableFrom=${this.formatDate(this.form.availableFrom)}&availableUntil=${this.formatDate(this.form.availableUntil)}`;

          console.log("queryString",queryString);

          const endpoint = this.isEditing
            ? `/schedule/updateAvailabilityById${queryString}`
            : '/schedule/setAvailability';



          // const payload = {
          //   coachId: this.form.coachId,
          //   availableFrom: this.formatDate(this.form.availableFrom),
          //   availableUntil: this.formatDate(this.form.availableUntil),
          // };

          // if (this.isEditing) payload.id = this.form.id;

          this.$http
            .post(endpoint)
            .then(() => {
              this.$message.success(this.isEditing ? '更新成功' : '添加成功');
              this.showAddDialog = false;
              this.fetchAvailability();
            })
            .catch((error) => {
              this.$message.error('操作失败');
              console.error(error);
            });
        }
      });
    },
    // 格式化日期
    // formatDate(date) {
    //   const d = new Date(date);
    //   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    // },
    // 分页切换
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchAvailability();
    },
  },
};
</script>

<style scoped>
.availability-page {
  padding: 20px;
}

.actions {
  margin-bottom: 20px;
}

.search-input {
  width: 200px;
  margin-left: 10px;
}
</style>
